import React, { useState } from 'react';
import { BookOpenIcon, PrinterIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { ManualViewer } from '../ManualViewer';
import { ZoomablePage } from '../ZoomablePage';
import { Carousel } from '../Carousel';
import { Lightbox } from '../Lightbox/Lightbox';
import { MANUAL_PAGES, PATTERN_PAGES, SAMPLE_MODEL } from '../../data/collection';
function PartLabel({
  icon,
  children
}: {
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return <p className="inline-flex items-center gap-2 rounded-full bg-paper px-4 py-2 text-[0.95rem] font-extrabold text-graphite ring-1 ring-inset ring-graphite/10" data-id="element-230" data-mp="2y27iazb8osez">
      {icon}
      {children}
    </p>;
}
export function ModelPreviewSection() {
  const [manualIndex, setManualIndex] = useState<number | null>(null);
  const [patternIndex, setPatternIndex] = useState<number | null>(null);
  return <section id="modelo" aria-labelledby="modelo-title" className="w-full bg-ivory-deep" data-id="element-231" data-mp="2fbprj09yw6w9">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-232" data-mp="1ynhr89ndf8b2">
        <SectionHeading id="modelo-title" title="Mirá un modelo por dentro antes de elegir." intro={`Recorré el ${SAMPLE_MODEL.name} del ${SAMPLE_MODEL.volume}, página por página, tal como aparece en el manual. Después, mirá las hojas de su molde.`} data-id="element-233" data-mp="1ypuacq4v7opp" />

        <div className="mt-12" data-id="element-234" data-mp="1ku8m4l6gh8yc">
          <PartLabel icon={<BookOpenIcon className="h-4 w-4 text-coral-ink" aria-hidden data-id="element-236" data-mp="1fxi7m2aaulf1" />} data-id="element-235" data-mp="1fx03kjheb2wk">Manual de confección</PartLabel>
          <div className="mt-6" data-id="element-237" data-mp="1axvqhhrcol0y">
            <ManualViewer pages={MANUAL_PAGES} modelName={SAMPLE_MODEL.name} volume={SAMPLE_MODEL.volume} onOpen={setManualIndex} data-id="element-238" data-mp="1awu78q06ks85" />
          </div>
        </div>

        <div className="mt-16 border-t border-dashed border-coral/40 pt-12 lg:mt-20" data-id="element-239" data-mp="31akwzpcn68p5">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-14 [&>*]:min-w-0" data-id="element-240" data-mp="3188k3qlqqoiy">
            <div data-id="element-241" data-mp="3fgd5kx4akr5d">
              <PartLabel icon={<PrinterIcon className="h-4 w-4 text-sage-ink" aria-hidden data-id="element-243" data-mp="3ffbifua04e7a" />} data-id="element-242" data-mp="3ffuyt6k06uj7">Moldes para imprimir</PartLabel>
              <h3 className="mt-5 font-serif text-[1.5rem] font-semibold leading-tight text-graphite sm:text-[1.75rem]" data-id="element-244" data-mp="3k8eeqa65y1r6">
                Así se ve el molde del mismo vestido.
              </h3>
              <p className="mt-3 text-[1.05rem] leading-relaxed text-graphite-soft" data-id="element-245" data-mp="3bfb1o2zfjqx2">
                Tres páginas del PDF de moldes del Volumen 2: el esquema de armado y dos hojas con los diez talles, a
                escala real y con margen de 7 mm incluido.
              </p>
              <p className="mt-3 text-[0.95rem] leading-relaxed text-graphite-soft" data-id="element-246" data-mp="3p6pqwrjxkock">
                Son muestras para que veas el contenido. Para coser, imprimís desde el PDF original que recibís con la
                colección.
              </p>
            </div>
            <Carousel items={PATTERN_PAGES} label="Hojas del molde" grid="md-3" itemClassName="w-[62%] sm:w-[40%]" getKey={page => page.file} renderItem={(page, index) => <figure className="w-full" data-id="element-248" data-mp="266qiq09bz03x">
                  <ZoomablePage image={page} label={page.caption} onOpen={() => setPatternIndex(index)} data-id="element-249" data-mp="2k6rej1aqnhcj" />
                  <figcaption className="mt-2.5 text-[0.92rem] font-semibold text-graphite" data-id="element-250" data-mp="2f7euspf5yqe6">{page.caption}</figcaption>
                </figure>} data-id="element-247" data-mp="2ipugnqe53cav" />
          </div>
        </div>
      </div>

      <Lightbox items={MANUAL_PAGES} index={manualIndex} onClose={() => setManualIndex(null)} onNavigate={setManualIndex} label={`Manual de confección · ${SAMPLE_MODEL.name}`} data-id="element-251" data-mp="1nhju5wluvea7" />
      <Lightbox items={PATTERN_PAGES} index={patternIndex} onClose={() => setPatternIndex(null)} onNavigate={setPatternIndex} label={`Moldes para imprimir · ${SAMPLE_MODEL.name}`} counterNoun="Hoja" data-id="element-252" data-mp="1wgnf764l23rc" />
    </section>;
}